/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { Fragment, useEffect, useState } from 'react'
import { Modal } from 'antd-mobile'
import { observer } from 'mobx-react'
import { isMobile } from 'react-device-detect'
import { Schema$Pick } from '@v2/protocol/pick'
import useRootStore from '@store/useRootStore'
import { SIDE_MENU } from '@constants/index'
import { Button, CloseBtn } from '@styles/button.style'
import { ModalBg } from '@styles/base.style'
import { ReplyTargetUser } from '@store/messageStore'
import MessageContent from './MessageContent'
import { FROM_VIEW_TYPE } from '@v2/constants/common'

interface MessageContentDrawerProps {
  visible: boolean
  setVisible: (arg: boolean) => void
  receive?: ReplyTargetUser
  targetPick?: Schema$Pick
  action?: string
  messageType?: string
  useRequestWaitTimer?: boolean
  fromViewType: FROM_VIEW_TYPE
  onAction?: () => void
  onCancel?: () => void
}

const MessageContentPopup: React.FC<MessageContentDrawerProps> = (props: MessageContentDrawerProps) => {
  const {
    visible,
    setVisible,
    receive,
    targetPick,
    action,
    messageType,
    useRequestWaitTimer,
    fromViewType,
    onAction,
    onCancel,
  } = props
  const [publishPick, setPublishPick] = useState(targetPick)
  const { globalStore, bettingHistoryStore, componentStore } = useRootStore()
  const className = []
  className.push('short-top pc-close-btn-modal white-popup')
  className.push('message-popup')
  if (componentStore.extraClubId) {
    className.push('club-message-popup')
  }
  // 베팅 공유로 변경 시
  if (globalStore.isAvailableMenu(SIDE_MENU.PICK)) {
    className.push('pick-version')
  }
  if (publishPick) {
    className.push('publish-pick')
  }
  if (bettingHistoryStore.selectedBettingHistory[FROM_VIEW_TYPE.MESSAGE]) {
    className.push('betting-shared')
  }

  useEffect(() => {
    if (visible) {
      if (onCancel) {
        onCancel()
      }
    } else {
      if (onAction) {
        onAction()
      }
    }
  }, [visible])

  const onClickMessagePopupCloseButton = () => {
    setVisible(false)
    globalStore.setIgnoreVisibleChangeHandler(false)
    // bettingHistoryStore.resetSelectedBettingHistoryAll(fromViewType)
  }

  if (visible) {
    setTimeout(() => {
      const messageContentPopup: HTMLElement = document.querySelector('.message-content-popup')
      if (messageContentPopup) {
        const prevNode = messageContentPopup.previousElementSibling
        const parent = messageContentPopup.parentElement.parentElement
        if (prevNode.className && prevNode.className === 'am-modal-mask') {
          prevNode.className += ' message-content-popup-mask'
        }
        if (parent && parent.id.indexOf('am-modal-container') > -1) {
          parent.className += ' message-content-popup-container'
        }
      }
    }, 300)
  }

  globalStore.updateVisibleModalList(visible, 'MessageContentPopup:visible')

  return (
    <Fragment>
      <Modal
        popup
        wrapClassName="message-content-popup"
        visible={visible}
        maskClosable={false}
        animated={isMobile}
        animationType="slide-up"
        onClose={onClickMessagePopupCloseButton}
        className={className.join(' ')}
        onShow={() => {
          console.log('onShow')
        }}
      >
        <Button
          circle
          onClick={onClickMessagePopupCloseButton}
          css={CloseBtn}
          className="close-btn modal-circle-close-btn">
          <span className="close-txt">닫기</span>
        </Button>
        <MessageContent
          visible={visible}
          setVisible={setVisible}
          receive={receive}
          action={action}
          messageType={messageType}
          publishPick={publishPick}
          setPublishPick={setPublishPick}
          useRequestWaitTimer={useRequestWaitTimer}
          fromViewType={fromViewType}
        />
        <ModalBg onClick={onClickMessagePopupCloseButton}/>
      </Modal>
    </Fragment>
  )
}

export default observer(MessageContentPopup)
